
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class ApprovalOutLaborGrid extends Serenity.EntityGrid<ApprovalOutLaborRow, any> {
        protected getColumnsKey() { return 'Sales.ApprovalOutLabor'; }
        protected getIdProperty() { return ApprovalOutLaborRow.idProperty; }
        protected getInsertPermission() { return ApprovalOutLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalOutLaborRow.localTextPrefix; }
        protected getService() { return ApprovalOutLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}